import { APP_INSTALLER_HEIGHT } from "@constants/ui";
import usePreference from "@hooks/usePreference";
import { cn } from "kz-ui-sdk";
import styles from "./ShineCircleBg.module.css";

interface ShineCircleBgProps {
  className?: string;
}

const ShineCircleBg = ({ className }: ShineCircleBgProps) => {
  const { isDisplayAppInstaller } = usePreference();

  return (
    <div
      className={cn(
        "-translate-start-1/2 absolute start-1/2 aspect-square max-h-[300px] w-full max-w-md overflow-hidden",
        className,
      )}
      style={{
        top: -(isDisplayAppInstaller ? 15 + APP_INSTALLER_HEIGHT : 15),
      }}
    >
      <img
        src="/images/mega-share/shine-circle.png"
        alt="shine circle bg"
        className={cn(
          "absolute start-0 top-0 aspect-square w-full scale-[1.2] object-contain opacity-30",
          styles.shineCircle,
        )}
      />
    </div>
  );
};

export default ShineCircleBg;
